import { CacheType, createObservableDataAction, IAction, IActionContext, ICreateActionContext } from '@msdyn365-commerce/core';
import { IActionInput } from '@msdyn365-commerce/retail-proxy';
import { getCIROrderTrackingBySalesIdInput } from './DataActionExtension.g';
import { ICIROrderTrackingLineData } from './DataServiceEntities.g';

export class TrackingNumberInput implements IActionInput {
    public salesOrderID: string;
    constructor(salesOrderID: string) {
        this.salesOrderID = salesOrderID;
    }
    public getCacheKey = () => `${this.salesOrderID}`;
    public getCacheObjectType = () => 'SalesOrders';
    public dataCacheType = (): CacheType => 'application';
    public shouldCacheOutput = () => true;
}

const createInput = (inputData: ICreateActionContext): IActionInput => {
    return getCIROrderTrackingBySalesIdInput('SO005891');
};

export async function TrackingNumberAction(input: TrackingNumberInput, ctx: IActionContext): Promise<ICIROrderTrackingLineData[]> {
    return [];
}

export const getTrackingActionDataAction = createObservableDataAction({
    id: 'GetTrackingNumber',
    action: <IAction<ICIROrderTrackingLineData[]>>TrackingNumberAction,
    input: createInput
});

export default getTrackingActionDataAction;
